/* RestEase: scroll effects driven by Lenis (needs restease-lenis.js first).
   1. Parallax  - images drift slightly slower than the page.
   2. Scrub     - cards, lines, stats and table rows animate in step with
                  the scroll position (scroll back up and they reverse).
   3. Progress  - the header progress bar follows Lenis frame by frame.
   Everything is skipped when Lenis is off (theme editor, reduced motion),
   so content always shows normally there. Content is never hidden by CSS:
   start states are set here, in JS, only once Lenis is running.

   Add your own:
     data-re-parallax="0.08"   on an image inside a box with overflow:hidden
     data-re-scrub="up|left|right|line"  on any element */
(function () {
  function boot() {
    var lenis = window.lenis;
    if (!lenis) return;
    var vh = window.innerHeight;
    var mqMobile = window.matchMedia('(max-width: 768px)');

    function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
    function ease(t) { return 1 - Math.pow(1 - t, 3); }
    function all(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

    /* ---------- 1. Parallax ---------- */
    var PARALLAX = [
      ['[id*="__proven_results_grid"] .overflow-hidden > img', 0.07],
      ['.re-sci__media .re-sci__img', 0.08],
      ['.re-val__media .re-val__img', 0.06]
    ];
    var px = [];
    PARALLAX.forEach(function (p) { all(p[0]).forEach(function (el) { px.push({ el: el, s: p[1] }); }); });
    all('[data-re-parallax]').forEach(function (el) { px.push({ el: el, s: parseFloat(el.getAttribute('data-re-parallax')) || 0.08 }); });
    px.forEach(function (p) { p.el.style.willChange = 'transform'; p.el.style.transformOrigin = '50% 50%'; });

    /* Hero: the slide stack sinks slower than the page as you scroll past it. */
    var hero = document.querySelector('[id*="__main_page_vedio"]');
    var heroSlides = hero && hero.querySelector('[class*="hero-slides-"]');
    if (heroSlides) { hero.style.overflow = 'clip'; heroSlides.style.willChange = 'transform'; }

    /* ---------- 2. Scrub ---------- */
    var SCRUB = [
      ['.re-sci__callout', 'left', 0],
      ['.re-sci__connector', 'line', 0.1],
      ['.re-sci__tree', 'line', 0],
      ['.re-sci__stat', 'up', 'stagger'],
      ['.re-sci__step', 'up', 0],
      ['.re-val__table tbody tr', 'right', 'stagger'],
      ['.re-val__table tfoot tr', 'up', 0.15],
      ['.re-blog__item', 'up', 'stagger']
    ];
    var sc = [];
    SCRUB.forEach(function (c) {
      all(c[0]).forEach(function (el, i) {
        sc.push({ el: el, type: c[1], delay: c[2] === 'stagger' ? i * 0.08 : c[2] });
      });
    });
    all('[data-re-scrub]').forEach(function (el) { sc.push({ el: el, type: el.getAttribute('data-re-scrub') || 'up', delay: 0 }); });
    sc.forEach(function (s) {
      s.el.style.willChange = 'transform, opacity';
      if (s.type === 'line') s.el.style.transformOrigin = '50% 0%';
    });

    function scrubStyle(s, t) {
      var e = ease(t), st = s.el.style;
      if (s.type === 'line') { st.transform = 'scaleY(' + e + ')'; return; }
      var d = (1 - e) * 36;
      st.opacity = (0.15 + 0.85 * e).toFixed(3);
      st.transform = s.type === 'left' ? 'translate3d(' + d + 'px,0,0)'
                   : s.type === 'right' ? 'translate3d(' + (-d) + 'px,0,0)'
                   : 'translate3d(0,' + d + 'px,0)';
    }

    /* ---------- 3. Progress bar ---------- */
    var bar = document.querySelector('header.site-header .re-progress');

    /* ---------- frame update ---------- */
    function update() {
      var y = lenis.animatedScroll;

      if (heroSlides) {
        /* On phones the image sits above the text (16:9), so no hero parallax there */
        if (mqMobile.matches) { heroSlides.style.transform = ''; }
        else {
          var hh = hero.offsetHeight;
          if (y < hh + 50) heroSlides.style.transform = 'translate3d(0,' + (Math.min(y, hh) * 0.3).toFixed(1) + 'px,0)';
        }
      }

      for (var i = 0; i < px.length; i++) {
        var p = px[i], box = p.el.parentElement.getBoundingClientRect();
        if (box.bottom < -100 || box.top > vh + 100) continue;
        var off = (box.top + box.height / 2) - vh / 2;
        var scale = 1 + p.s * 1.6;
        var max = box.height * (scale - 1) / 2;
        var ty = clamp(-off * p.s, -max, max);
        p.el.style.transform = 'translate3d(0,' + ty.toFixed(1) + 'px,0) scale(' + scale.toFixed(3) + ')';
      }

      for (var j = 0; j < sc.length; j++) {
        var s = sc[j], r = s.el.getBoundingClientRect();
        /* 0 when the element's top reaches the bottom of the screen,
           1 once it has travelled 35% of the screen height */
        var t = clamp((vh - r.top) / (vh * 0.35) - s.delay * 4, 0, 1);
        if (t === s.last) continue;
        s.last = t;
        scrubStyle(s, t);
      }

      if (bar) bar.style.setProperty('--re-progress', clamp(lenis.progress || 0, 0, 1).toFixed(4));
    }

    lenis.on('scroll', update);
    window.addEventListener('resize', function () { vh = window.innerHeight; update(); });
    window.addEventListener('load', update);
    update();
  }

  if (window.lenis) boot();
  else window.addEventListener('DOMContentLoaded', boot);
})();
